export default "__VITE_ASSET__DtZKujs7__"